<template>
  <div class="card border-0 bg-default">
    <div class="card-body">
      <div class="d-flex flex-wrap align-items-center">
        <i class="fa fa-money font-size-50 mr-3" :style="setColor(sumTotal,sumTotalQR,sumWithdrawTotal).color" />
        <div>
          <div class="font-size-30 font-weight-bold" :style="setColor(sumTotal,sumTotalQR,sumWithdrawTotal).color">{{ setComma(profitTotal) }} บาท </div>
          <div class="font-size-18 font-weight-bold" :style="setColor(sumTotal,sumTotalQR,sumWithdrawTotal).color" v-if="profitTotal > 0">กำไร</div>
          <div class="font-size-18 font-weight-bold" :style="setColor(sumTotal,sumTotalQR,sumWithdrawTotal).color" v-else>ขาดทุน</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'KitChart11',
  props: [
    'chartDataProfit',
    'profitTotal',
    'sumTotal',
    'sumTotalQR',
    'sumWithdrawTotal',
  ],
  methods: {
    setColor(sumdeposit, sumdepositQR, sumwithdraw) {
      const nameColorUp = [{ color: 'color: #14ab84' }]
      const nameColorDown = [{ color: 'color: #f04e3f' }]
      return (Math.round(sumdeposit) + Math.round(sumdepositQR)) > Math.round(sumwithdraw) ? nameColorUp[0] : nameColorDown[0]
    },
    setComma(value) {
      if (value > 0 && value !== null) {
        // var parts = value.toString().split('.')
        // var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '')
        // return num
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        // // eslint-disable-next-line no-redeclare
        // var parts = value.toString().split('.')
        // // eslint-disable-next-line no-redeclare
        // var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '')
        // return num
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
  },
}
</script>
<style lang="scss" module>
// @import "./style.module.scss";
</style>
